import { styled } from 'stitches.config';

type PropTypes = {
  children: React.ReactNode;
};

function FormTitle({ children }: PropTypes) {
  return <FormTitleWrapper>{children}</FormTitleWrapper>;
}

const FormTitleWrapper = styled('span', {
  fs: 9,
  lineHeight: '$lh133',
  color: '$secondary2',
  mb: 4,
  display: 'block',
});

export default FormTitle;
